import React from 'react'
import { observer } from 'mobx-react'
import { Thead, Tr } from '@chakra-ui/react'
import TableCell from './TableCell'

export interface TableHeaderProps {
  columns: string[]
}

const TableHeader = ({ columns }: TableHeaderProps) => {
  return (
    <Thead position="sticky" top="0" zIndex="1">
      <Tr>
        {columns.map(column => (
          <TableCell key={column} value={column} isHeader={true} />
        ))}
      </Tr>
    </Thead>
  )
}

export default observer(TableHeader)
